import React, { useState } from "react";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { extractApiErrorData } from "../../../utilities/api";
import { uiNotification } from "../../../services/UINotificationService";
import { ModalError } from "../../../boxes/ModalError/ModalError";
import { useResendPortalBulkInviteMutation } from "../../../api/patient/useResendPortalBulkInviteMutation";

const INVITE_LIMIT = 20;

export function withBulkInvite(Component) {
  return (props) => {
    const { tClients } = useAppTranslation.Clients();

    const [selected, setSelected] = useState([]);
    const [errors, setErrors] = useState([]);

    const { mutateAsync, isLoading } = useResendPortalBulkInviteMutation({
      onError: (e) => {
        const errors = extractApiErrorData(e)?.errors || [];

        if (errors.length) {
          setErrors(errors);
        } else {
          uiNotification.error(tClients("bulkInvite.error"));
        }
      },
      onSuccess: (data) => {
        const errors = data?.data?.data?.errors || [];

        if (errors.length) {
          setErrors(errors);
        } else {
          setSelected([]);
          setErrors([]);

          uiNotification.success(tClients("bulkInvite.success"));
        }
      },
    });

    const getIsSelected = (id) => selected.includes(id);

    const toggleSelected = (id) => {
      if (selected.includes(id)) {
        setSelected(selected.filter((i) => i !== id));
      } else {
        setSelected([...selected, id]);
      }
    };

    const onSendInvites = () => {
      if (selected.length > INVITE_LIMIT) {
        return Promise.reject(
          uiNotification.error(tClients("bulkInvite.tooMany")),
        );
      }

      return mutateAsync({ patientIds: selected.map(Number) });
    };

    return (
      <>
        <Component
          {...props}
          bulkInvite={{
            getIsSelected,
            toggleSelected,
            isLoading,
            onBulkSelect: (selectedUsers) => setSelected(selectedUsers),
            count: selected.length,
            request: (nextOnSuccess) => {
              onSendInvites().then(nextOnSuccess);
            },
            reset: () => {
              setSelected([]);
            },
          }}
        />
        {errors.length > 0 && (
          <ModalError
            isOpen
            onClose={() => setErrors([])}
            onOk={() => setErrors([])}
          >
            <div className="d-flex flex-column gap-4">
              <h4 className="m-b-10">{tClients("bulkInvite.cannotInvite")}:</h4>
              {errors.map((error) => (
                <div key={error.patient_id}>
                  <b>{error.patient_name} </b>
                  {tClients(`bulkInvite.apiError.${error.error}`, error.error)}
                </div>
              ))}
            </div>
          </ModalError>
        )}
      </>
    );
  };
}
